/* eslint-disable camelcase */
import React, { useEffect, useCallback, useRef } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { useSnapshot } from 'valtio';

import { refsStore, eventsStore } from '../../managers/globalState';

import Overlay from '../overlays';
import GridList from '../grid_list';
import Filter from '../filter';
import GlobeIcon from '../../../www/assets/images/globe_icon.min.svg';
import EventSVG from '../../../www/assets/images/event-marker.svg';

import '../../../www/assets/css/overlays/events.css';

import {
	updateYear,
	updateCategory,
	filterEvents
} from '../../helpers/processEvents';
import { EVENT_CATEGORIES } from '../../config/constants';
import { Config } from '../../config/config';


/**
 * Constant vars
 */
const THUMB_WIDTH = 159;
const THUMB_HEIGHT = 102;
const ITEM_PADDING = 30;
const TITLE_TEXT = 'الكوارث الطبيعية';
const BUTTON_TEXT = 'عرض على الكرة الأرضية';

/**
 * ButtonText component
 */
const ButtonText = () => <span>{BUTTON_TEXT}</span>;

/**
 * Individual EventItem component to represent each event in the grid
 */
const EventItem = props => {
	const { title, external_id, list_image_src, formatted_date, onItemClick } = props;
	let srcUrl = list_image_src;
	srcUrl = srcUrl.replace('$DATAAREA', 'earth');

	const onClick = useCallback(() => {
		onItemClick(external_id);
	}, [onItemClick, external_id]);

	const imgStyle = {
		maxWidth: `${THUMB_WIDTH}px`,
		height: `${THUMB_HEIGHT}px`
	};

	return (
		<div className='event-item' onClick={onClick}>
			<img className='thumbnail' style={imgStyle} src={srcUrl} alt={title} />
			<span className='event-date'>{formatted_date}</span>
			<span className='event-title'>{title}</span>
		</div>
	);
};


/**
 * Events Overlay component
 */
const EventsOverlay = ({ closeOverlay, isMobile, isWindows }) => {
	const mainRef = useRef();
	const scrollableNodeRef = React.createRef();

	// get the global state
	const { yearIndex, categoryIndex, events, cats } = useSnapshot(eventsStore.state);

	// get the get ref.
	const { get } = useSnapshot(refsStore.state);

	const { eventYears } = get('content');
  let eventsCategories = cats.map(v => v[1])
	// onMount, we want to set showOnGlobe to false
	useEffect(() => {
		// then let's set it to false
		get('scene').showAllEventsOnGlobe(false);
	}, [get]);

	// data filtering
	let filteredData = null;
	if (eventYears && eventYears[yearIndex]) {
		const key = eventYears[yearIndex];
		if (events[key]) {
			const data = [...events[key]];
			filteredData = filterEvents(data, categoryIndex);
		}
	}

	// navToEvent callback
	const navToEvent = useCallback(eventId => {
		closeOverlay(true);

		const routeManager = get('route');

		routeManager.goToEvent(eventId);
	}, [closeOverlay, get]);

	// viewOnGlobe callback
	const viewOnGlobe = useCallback(() => {
		// Remove any active video before showing events on globe.
		get('video').setVideoQuery(null);

		// Set the global state.
		const routeManager = get('route');

		if (routeManager?._history?.location?.pathname) {
			const { pathname } = routeManager._history.location;
			if (pathname.indexOf('eo_event') >= 0 || pathname.indexOf('spacecraft') >= 0) {
				routeManager.navigate('/vitalsign?vitalsign=visible_earth&altid=0&animating=f&showOnGlobe=t');
			} else {
				get('scene').showAllEventsOnGlobe(true);
			}
		}

		// Close the overlay  pass false since no event was selected.
		closeOverlay(false);
	}, [closeOverlay, get]);

	// compose overlay
	return (
		<Overlay type='events' ref={mainRef}>
			<Overlay.Header
				back
				onClose={closeOverlay}
				isMobile={isMobile}
				title={TITLE_TEXT}
				Icon={EventSVG}
			>
				<div className='events-header-content'>
					<div className='events-header-filters'>
						<Filter
							type='dropdown'
							style={{ padding: 10 }}
							allItems={eventYears}
							selectedIndex={yearIndex}
							updateItem={updateYear}
						/>
						<Filter
							type='dropdown'
							style={{ padding: 10 }}
							allItems={eventsCategories}
							selectedIndex={categoryIndex}
							updateItem={updateCategory}
						/>
					</div>
					<div className='globe-border'>
						<div className='button' onClick={viewOnGlobe}>
							<GlobeIcon />
							<ButtonText />
						</div>
					</div>
				</div>
			</Overlay.Header>
			<div className='content-mask'>
				{
					filteredData
					&& (
						<GridList
							rowClassName='flex-grid-row'
							minPerRow={2}
							dataList={filteredData}
							itemSize={THUMB_WIDTH + ITEM_PADDING * 2}
							itemPadding={[ITEM_PADDING, ITEM_PADDING]}
							itemComponent={<EventItem onItemClick={navToEvent} />}
							scrollableRef={isWindows ? scrollableNodeRef : mainRef}
						/>
					)
				}
			</div>
		</Overlay>
	);
	// compose overlay
	return (
		<Overlay type='events' ref={mainRef}>
			{isWindows ?
				<SimpleBar scrollableNodeProps={{ ref: scrollableNodeRef }} style={{ height: '100%' }}>
					{overlayComponents}
				</SimpleBar> :
				overlayComponents}
		</Overlay>
	);
};


export default EventsOverlay;
